export default "__VITE_ASSET__DoFXIATE__";